import { Component, Input } from '@angular/core';

@Component({
  selector: 'sp-table-head-cell',
  standalone: false,
  templateUrl: './table-head-cell.component.html',
  styleUrls: ['./table-head-cell.component.scss']

})
export class TableHeadCellComponent {
  @Input() width = null;
  @Input() align = null;

  constructor() {}
}